import {
  NO_AMP,
  NO_APLICA,
  INFO_MODULE
} from '@atresmedia/datalayer/lib/utils/constants';
import {
  getDate,
  getTime,
  getMeta,
  getValueSession,
  removeValueSession
} from '@atresmedia/datalayer/lib/utils/functions';

export default () => {
  const { hostname } = document.location;
  const channel = hostname.split('.')[1] || NO_APLICA;
  const tipoContenido = getMeta('tipo-contenido');
  const timeModified = getMeta('article:modified_time');
  const timePublished = getMeta('article:published_time');
  const paginaSeriePrograma = getMeta('serie-programa');
  const vertical = getMeta('site-name');
  const tipoPagina = getMeta('tipo-pagina');
  const error = getMeta('error');
  const tipoConsumo = 'WEB';
  const consentAAM =
    localStorage.getItem('aamConsentValue') === 'true' ? '0' : '1';
  const infoModulo = getValueSession(INFO_MODULE);

  if (infoModulo) {
    removeValueSession(INFO_MODULE);
  }

  return {
    tipoContenido,
    canal: channel,
    fechaPublicacion: getDate(timePublished),
    fechaActualizacion: getDate(timeModified),
    horaPublicacion: getTime(timePublished),
    horaActualizacion: getTime(timeModified),
    paginaSeriePrograma,
    tipoConsumo,
    error404: error === 'true' ? '404' : undefined,
    amp: NO_AMP,
    consentAAM,
    vertical,
    tipoPagina,
    infoModulo
  };
};
